import { TApiTaskDetails } from "@timenotes/shared/src/services/api-client/types"
import { useUpdateTaskMutation } from "@timenotes/shared/src/services/tasks/queries/use-update-task-mutation"
import InPlaceEditContainer from "components/timenotes/in-place-edit-container"
import { useParams } from "react-router-dom"
import { useTaskDetailsModal } from "./task-details-modal"
import { message } from "antd"
import { getApiErrorMessage } from "@timenotes/shared/src/services/api-client"
import { LoadingOutlined } from "@ant-design/icons"
import { useState } from "react"
import { TaskOptions } from "./task-options"
import { TaskArchivedLabel } from "../task-archived-label"

interface TaskDetailsModalTitleProps {
  task: TApiTaskDetails
}

export const TaskDetailsModalTitle = (props: TaskDetailsModalTitleProps) => {
  const {
    task,
  } = props

  const {
    projectId
  }= useParams<{
    projectId: string 
  }>()

  const {
    closeTaskModal,
  } = useTaskDetailsModal()

  if (!projectId) throw "Task modal can not be displayed due to lack of project ID!"

  const [newNamePreview, setNewNamePreview] = useState<string | undefined>()

  const updateTaskMutation = useUpdateTaskMutation({
    projectId: projectId, 
  })

  const handleTaskNameUpdate = (newName: string) => {
    setNewNamePreview(newName)

    updateTaskMutation.mutate({
      taskId: task.id,
      body: {
        name: newName
      }
    }, {
      onError: (errors) => {
        message.error(getApiErrorMessage({ errors: errors }, 'name'))
      },
      onSettled: () => {
        setNewNamePreview(undefined)
      }
    })
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'space-between',
        width: '100%',
        gap: '10px',
      }}
    >
      <InPlaceEditContainer
        value={task.name}
        onChange={handleTaskNameUpdate}
      >
        {newNamePreview || task.name} {updateTaskMutation.isLoading && <LoadingOutlined />}
      </InPlaceEditContainer>

      <div
        style={{
          marginRight: '30px',
          marginLeft: 'auto',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {task.state == 'archived' && (
          <div>
            <TaskArchivedLabel />
          </div>
        )}

        <TaskOptions 
          taskId={task.id}
          taskState={task.state}
          projectId={projectId}
          onDelete={closeTaskModal}
        />
      </div>
    </div>
  )
}